import jwtAuthAxios from "../auth/jwtAuth";

// Plantillas de reportes: la configuración guardada de un reporte. Generar una plantilla pide un archivo de «Descargas»
// con el local y el período elegidos (generatedFileServices.waitUntilReady espera a que esté listo).
const reportTemplateServices = {};

reportTemplateServices.list = async () => {
    const { data } = await jwtAuthAxios.get("/automations/report_templates");
    return data;
};

reportTemplateServices.get = async (id) => {
    const { data } = await jwtAuthAxios.get(`/automations/report_templates/${id}`);
    return data;
};

reportTemplateServices.create = async (template) => {
    const { data } = await jwtAuthAxios.post("/automations/report_templates", { report_template: template }, { silentErrors: true });
    return data;
};

reportTemplateServices.update = async (id, template) => {
    const { data } = await jwtAuthAxios.patch(`/automations/report_templates/${id}`, { report_template: template }, { silentErrors: true });
    return data;
};

reportTemplateServices.remove = async (id) => {
    await jwtAuthAxios.delete(`/automations/report_templates/${id}`);
};

// El reporte de la plantilla con el local y el período elegidos, completo, para verlo en la pantalla sin generar el PDF.
reportTemplateServices.preview = async (id, { from, to, store_id }) => {
    const { data } = await jwtAuthAxios.post(`/automations/report_templates/${id}/preview`, { from, to, store_id }, { silentErrors: true });
    return data;
};

reportTemplateServices.generate = async (id, { from, to, store_id }) => {
    const { data } = await jwtAuthAxios.post(`/automations/report_templates/${id}/generate`, { from, to, store_id }, { silentErrors: true });
    return data;
};

export default reportTemplateServices;
